import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableRespontsView.
 * @extends JetView
 */
export default class TableRespontsView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'tableResponts', // Unique identifier for the datatable
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
            select: true, // Enables row selection
            columns: [
                // Column definitions for the datatable
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // Column for Id
                {
                    id: 'Responts',
                    header: _('Respuesta'), // Localized header for responses
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'State',
                    header: _('Estado'), // Localized header for state
                    editor: 'combo', // Combo editor for state selection
                    options: [
                        // Options for the combo editor
                        { id: '0', value: _('Respondido') }, // Localized value for responded
                        { id: '1', value: _('No Respondido') }, // Localized value for not responded
                    ],
                    width: 80,
                    sort: 'int',
                },
                {
                    id: 'UserCreated',
                    header: _('Usuario Creo'), // Localized header for user who created
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'DateCreation',
                    header: _('Fecha de creación'), // Localized header for creation date
                    width: 100,
                    sort: 'int',
                },
            ],
            math: true, // Enables mathematical operations in the datatable
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager ID for pagination
            url: devConfig.geturlApi() + 'request/GetResponts', // API endpoint for data loading
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // URL for data loading

        // Event listener for loading details based on selected item
        this.on(this.app, 'detailsResponts:id', (item) => {
            grid.clearAll(); // Clears existing data in the grid
            grid.load(url + '?id=' + item.Id); // Loads new data based on selected item
        });

        // Event listener for item click to trigger user event
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieves the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Calls user event with item Id
        });

        // Event listener for player selection to load data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Loads data filtered by PlayerId
            );
        });

        // Event listener for double-clicking an item to show a popup
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieves the double-clicked item
            popup.show(); // Displays the popup
        });
    }
}

// FILE DOCUMENTED
